import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import moment from 'moment'
import _ from 'lodash'

import { addContactLog } from '../../actions'

import { Form, Button, Radio, Input, Select, DatePicker, Checkbox } from 'antd'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const FormItem = Form.Item
const TextArea = Input.TextArea
const Option = Select.Option

const disabledDate = current => {
  // Can not select days before today
  return current && current < moment().startOf('day')
}

const logFormFields = {
  appointment: [
    { name: 'appointmentDate', type: 'datePicker', label: 'Appointment date', rules: [{ required: true }] },
    { name: 'sendEmail', type: 'checkbox', label: 'Send email' }
  ],
  recall: [{ name: 'recallDate', type: 'datePicker', label: 'Recall date', rules: [{ required: true }] }],
  dropOff: [
    {
      name: 'dropOffReason',
      type: 'radioGroup',
      options: [{ value: 'noInterest', title: 'No interest' }, { value: 'noPotential', title: 'No potential' }],
      initialValue: 'noInterest',
      label: 'Drop off reason'
    }
  ],
  notReached: [{ name: 'nextCallDate', type: 'datePicker', label: 'Next call', initialValue: null }],
  successfullyReached: []
}

// examples - how to specify new fields
// { name: 'aims', type: 'textArea', label: 'Aims' },
// {
//   name: 'delivery',
//   type: 'select',
//   options: [
//     { value: 'email', title: 'Send email' },
//     { value: 'post', title: 'By post' },
//     { value: 'fax', title: 'By fax' },
//     { value: 'skype', title: 'By Skype' }
//   ],
//   label: 'Delivery of documents'
// }

class FormAddLog extends Component {
  state = {
    reachedType: null,
    selectedAssignee: 'generic'
  }

  handleReachedTypeChange = e => {
    const reachedType = e.target.value

    this.setState({ reachedType })
  }

  handleAssigneeChange = value => {
    this.setState({ selectedAssignee: value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const {
      contactReached,
      match: { params },
      form: { validateFields },
      contact,
      addContactLog,
      user
    } = this.props

    validateFields((err, values) => {
      if (!err) {
        let previousStatus = null

        const contactLog = {
          contactId: contact.id,
          createdAt: Date.now(),
          createdBy: {
            id: user.data.uid,
            name_sync: user.data.displayName
          },
          data: values
        }

        if (contactReached) {
          // convert Moment obj to timestamp int
          if (values.recallDate) {
            contactLog.data.recallDate = parseInt(moment(values.recallDate).format('x'), 10)
          }
          if (values.appointmentDate) {
            contactLog.data.appointmentDate = parseInt(moment(values.appointmentDate).format('x'), 10)
          }
        } else {
          if (values.nextCallDate) {
            contactLog.data.nextCallDate = parseInt(moment(values.nextCallDate).format('x'), 10)
          }
          previousStatus = contact.status
        }

        addContactLog(params.projectId, contactLog, previousStatus)
      }
    })
  }

  generateFormFields = (formFields, isQuestion) => {
    const {
      form: { getFieldDecorator }
    } = this.props

    return [
      formFields.map(field => {
        let formElement

        switch (field.type) {
          case 'input':
            formElement = <Input />
            break

          case 'textArea':
            formElement = <TextArea rows={2} />
            break

          case 'select':
            formElement = (
              <Select>
                {field.options.map(o => (
                  <Option value={o.value} key={o.value}>
                    {o.title}
                  </Option>
                ))}
              </Select>
            )
            break

          case 'radioGroup':
            formElement = (
              <RadioGroup>
                {field.options.map(o => (
                  <Radio value={o.value} key={o.value}>
                    {o.title}
                  </Radio>
                ))}
              </RadioGroup>
            )
            break

          case 'datePicker':
            formElement = (
              <DatePicker
                disabledDate={disabledDate}
                showTime={{ format: 'HH:mm', minuteStep: 15 }}
                format='YYYY-MM-DD HH:mm'
                placeholder='Select Time'
              />
            )
            break

          case 'checkbox':
            formElement = <Checkbox>{field.title}</Checkbox>
            break

          default:
            break
        }

        return (
          <FormItem key={field.name} label={field.label} colon={false}>
            {/* if isQuestion, wrap it in 'questions: {}' */}
            {getFieldDecorator(isQuestion ? `questions.${field.name}` : field.name, {
              initialValue: field.initialValue || null,
              rules: field.rules
            })(formElement)}
          </FormItem>
        )
      })
    ]
  }

  render () {
    const { reachedType, selectedAssignee } = this.state
    const {
      contactReached,
      match: { params },
      form: { getFieldDecorator },
      projects,
      loading,
      companies
    } = this.props

    const currentProject = projects[params.projectId]
    // get Company Users - so we can use their names (users[userId]: { name_sync })
    const companyUsers = companies[currentProject.companyId].users

    // generate assignees Options for Select form element
    let assigneeOptions = [
      <Option key='generic' value='generic'>
        GENERIC
      </Option>
    ]
    reachedType === 'appointment' &&
      _.map(currentProject.roles, (permissionLevel, userId) =>
        // permissionLevel === Roles.PROJECT.SALESPERSON && // filter only Salespersons
        assigneeOptions.push(
          <Option key={userId} value={userId}>
            {companyUsers[userId].name_sync}
          </Option>
        )
      )

    let questionFields = []
    _.map(currentProject.questions, (question, questionId) => {
      questionFields.push({
        name: questionId,
        type: 'textArea',
        label: question.text,
        order: question.order
      })
    })
    questionFields = _.orderBy(questionFields, 'order', 'asc')

    return (
      <Form onSubmit={this.handleSubmit}>
        {/* if contact was reached */}
        {contactReached
          ? [
            <FormItem key='comment' label='Comment'>
              {getFieldDecorator('comment', {
                initialValue: null
              })(<TextArea rows={2} />)}
            </FormItem>,

            <h2 key='header' style={{ textAlign: 'center' }}>
                Questions
            </h2>,
            this.generateFormFields(questionFields, true),

            <FormItem key='reachedType' style={{ textAlign: 'center' }}>
              {getFieldDecorator('reachedType', {
                rules: [{ required: true }]
              })(
                <RadioGroup onChange={this.handleReachedTypeChange}>
                  <RadioButton checked={reachedType === 'recall'} value='recall'>
                      Re-call agreed
                  </RadioButton>
                  <RadioButton checked={reachedType === 'appointment'} value='appointment'>
                      Appointment scheduled
                  </RadioButton>
                  <RadioButton checked={reachedType === 'dropOff'} value='dropOff'>
                      Drop off
                  </RadioButton>
                  <RadioButton checked={reachedType === 'successfullyReached'} value='successfullyReached'>
                      Successfully reached
                  </RadioButton>
                </RadioGroup>
              )}
            </FormItem>
          ]
          : this.generateFormFields(logFormFields.notReached)}

        {/* APPOINTMENT - append sales person Select field */}
        {contactReached && reachedType === 'appointment' && (
          <FormItem label='Assignee'>
            {getFieldDecorator('assignee', {
              initialValue: 'generic',
              rules: [{ required: true }]
            })(<Select onChange={this.handleAssigneeChange}>{assigneeOptions}</Select>)}
          </FormItem>
        )}
        {/* APPOINTMENT - if generic assignee is selected, show also input field for her/his name */}
        {contactReached && reachedType === 'appointment' && selectedAssignee === 'generic' && (
          <FormItem label='Assignee name'>
            {getFieldDecorator('assigneeName', {
              rules: [{ required: true }]
            })(<Input />)}
          </FormItem>
        )}

        {/* generate all the other form fields - based on 'reachedType' */}
        {contactReached && reachedType && this.generateFormFields(logFormFields[reachedType])}

        <FormItem style={{ textAlign: 'right' }}>
          <Button key='button' type='primary' htmlType='submit' loading={loading.addContactLog}>
            Submit
          </Button>
        </FormItem>
      </Form>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects,
  user: state.user,
  loading: state.loading,
  companies: state.companies
})

const mapDispatchToProps = {
  addContactLog
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(withRouter(FormAddLog)))



// WEBPACK FOOTER //
// ./src/components/ContactModal/FormAddLog.js